import { render, staticRenderFns } from "./logisticssafety.vue?vue&type=template&id=420fd1e7&"
import script from "./logisticssafety.vue?vue&type=script&lang=js&"
export * from "./logisticssafety.vue?vue&type=script&lang=js&"
import style0 from "./logisticssafety.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports